module.exports = __webpack_public_path__ + "img/sv69.c5081a13.svg";